<template>
  <section class="xding-share"></section>
</template>
<script>
/******************************************
 ** dingding分享
 * @description 钉钉分享
 * @author stone
 *****************************************/
import * as dd from 'dingtalk-jsapi'
export default {
  name: 'dingdingShare',
  props: {
    options: {
      type: Object,
      default () {
        return {
          shareImgUrl: '',
          shareTitle: '',
          shareDescription: '',
          shareLink: ''
        }
      }
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {
    $route (to, from) {
      this.init()
    }
  },
  methods: {
    init () {
      const _this = this
      dd.ready(() => {
        // dd.ready参数为回调函数，在环境准备就绪时触发，jsapi的调用需要保证在该回调函数触发后调用，否则无效。
        dd.biz.navigation.setRight({
          show: true, // 控制按钮显示， true 显示， false 隐藏， 默认true
          control: true, // 是否控制点击事件，true 控制，false 不控制， 默认false
          text: '分享', // 控制显示文本，空字符串表示显示默认文本
          onSuccess: function (result) {
            // 如果control为true，则onSuccess将在发生按钮点击事件被回调
            dd.biz.util.share({
              type: 0,
              url: _this.options.shareLink,
              title: _this.options.shareTitle,
              content: _this.options.shareDescription,
              image: _this.options.shareImgUrl
            })
          }
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped></style>
